/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
var MarkPriseButton = xClass("MarkPriseButton", Event, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/homeScene_mark_prise.csb")
})
var MarkPriseButtonEvent = table([1, "TimeUp", "MARKPRISEBUTTONEVENT.TIMEUP"])
MarkPriseButton.prototype.ctor = function (endTime) {
    var self = this
    self.endTime = endTime
    self.nodeExist = true
    self.visible = true
    self.hided = false
    self.bind(self)
    self.btn = null
    self.init()
}
MarkPriseButton.prototype.init = function () {
    var self = this
    var btn = UIButton.create(self.getChildByName("icon"), true)
    self.btn = btn
    var clickLayer = cc.Layer.create()
    clickLayer.setContentSize(140, 120)
    clickLayer.setAnchorPoint(0.5, 0.5)
    clickLayer.setPositionX(self.getChildByName("time").getPositionX() - 40)
    clickLayer.setPositionY(self.getChildByName("time").getPositionY() - 40)
    clickLayer.setCascadeOpacityEnabled(true)
    self.addChild(clickLayer)
    var getRewardBTN = UIButton.create(clickLayer)
    getRewardBTN.setCascadeOpacityEnabled(true)
    getRewardBTN.on(UIButtonEvent.Click, handler(self, self.onClick))
    function refresh() {
        var time = self.getChildByName("time")
        if (!time) {
            return 
        }
        time.setString(UIUtils.formatTime(Math.max(self.endTime - Localhost.time(), 0)))
        var size = time.getContentSize()
        time.setPositionX(-size.width * time.getScaleX() / 2)
        if (self.endTime - Localhost.time() < 0) {
            self.dispatchEvent(table([1, "name", MarkPriseButtonEvent.TimeUp]))
        }
    }
    var time = self.getChildByName("time")
    time.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(refresh), cc.DelayTime.create(0.5))))
}
MarkPriseButton.prototype.setEndTime = function (endTime) {
    var self = this
    self.endTime = endTime
}
MarkPriseButton.prototype.getEndTime = function () {
    var self = this
    return self.endTime
}
MarkPriseButton.prototype.setVisible = function (visible) {
    var self = this
    self.visible = visible
    self.btn.setVisible(self.visible && !self.hided)
    var time = self.getChildByName("time")
    time.setVisible(self.visible && !self.hided)
}
MarkPriseButton.prototype.setHided = function (hided) {
    var self = this
    self.hided = hided
    self.btn.setVisible(self.visible && !self.hided)
    var time = self.getChildByName("time")
    time.setVisible(self.visible && !self.hided)
}
MarkPriseButton.prototype.onClick = function () {
    var self = this
    var [v00, v11] = self.getAnglePosition()
    var MarkPriseLogic = require("clover/panelBusLogic/MarkPriseLogic")
    MarkPriseLogic.create().start(null, table([1, "p00", v00], [1, "p11", v11]), table([1, "p00", v00], [1, "p11", v11]))
    DCAssist.dc4OpenModule(ModuleName.MARK_LIMIT_GIFT)
}
MarkPriseButton.prototype.shakeBox = function () {
    var self = this
    if (!self.visible || self.hided) {
        return 
    }
    self.btn.runAction(cc.Sequence.create(cc.Repeat.create(cc.Sequence.create(cc.RotateTo.create(0.1, -15), cc.RotateTo.create(0.1, 15)), 2), cc.RotateTo.create(0.1, 0)))
}
MarkPriseButton.prototype.getAnglePosition = function () {
    var self = this
    var icon = self.getChildByName("icon")
    var size = icon.getContentSize()
    var pos = cc.p(icon.getPosition())
    var v00 = self.convertToWorldSpace(cc.p(pos.x - size.width * icon.getScaleX() / 2, pos.y - size.height * icon.getScaleY() / 2))
    var v11 = self.convertToWorldSpace(cc.p(pos.x + size.width * icon.getScaleX() / 2, pos.y + size.height * icon.getScaleY() / 2))
    return [v00, v11]
}
module.exports = table([0, MarkPriseButton], [0, MarkPriseButtonEvent])
